
import { colors } from '~/helpers/colors'
export default {
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    selected: {
      type: Boolean,
      default: false,
    },
    hidden: {
      type: Boolean,
      default: false,
    },
    color: {
      type: String,
      required: true,
    },
    hexa: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    colorSwatch() {
      return colors[this.color].EN.toLowerCase()
    },
  },
}
